var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex min-h-[calc(100vh-68px)] md:items-center"},[_c('nuxt'),_vm._v(" "),_c('ToastContainerComponent')],1),_vm._v(" "),_c('FooterComponent'),_vm._v(" "),_c('PortalTarget',{attrs:{"name":"tooltip-root","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }